<template>
    <page-preloader v-if="promotionStatus === 'loading'"></page-preloader>
    <div v-else-if="!promotion" class="main v-promo">
        <bread-crumbs
            :defaultUrl="$router.resolve({ name: 'promo-list' }).href"
            :text="'Wróć do listy wszystkich promocji'"
        />
        <div>
            <p class="h5 -center">
                Promocja nie została odnaleziona
            </p>
        </div>
    </div>
    <main v-else-if="promotion" class="main v-promo" id="single-promo">
        <bread-crumbs
            :defaultUrl="$router.resolve({ name: 'promo-list' }).href"
            :text="'Wróć do listy wszystkich promocji'"
        />
        <div class="container">
            <header class="v-promo__header">
                <div class="v-promo__image c-fig c-fig--promos">
                    <img class="c-fig__img" :src="promotion.logo.urls.big" />
                </div>
                <div class="v-promo__headright">
                    <div class="v-promo__dates">
                        <p class="typo">
                            Od
                            <time datetime>{{ startAt }}</time>
                            do
                            <time datetime>{{ finishAt }}</time>
                        </p>
                        <p class="typo d-lg-none">
                            ({{ daysLeft.diff }} do końca promocji)
                        </p>
                    </div>

                    <div class="v-promo__name">
                        <button
                            @click="toggleFavorites(promotion.id)"
                            class="c-promos-like btn btn-link"
                            :class="{ 'is-active': promotion.favorite }"
                        >
                            <a-icon icon="Heart" />
                        </button>
                        <h1 class="typo typo--name">
                            {{ promotion.name }}
                            <span v-if="promotion.retailer_info"
                                >({{ promotion.retailer_info }})</span
                            >
                        </h1>
                    </div>

                    <div
                        v-if="setPromoTypeDetails.title"
                        class="v-promo__category d-flex flex-column align-items-start"
                    >
                        <div
                            class="typo d-flex align-items-center"
                            @click="
                                showPromoTypeDetails = !showPromoTypeDetails
                            "
                            data-toggle="collapse"
                            aria-haspopup="true"
                            :data-target="`#promo-type-details`"
                            aria-expanded="false"
                            aria-controls="promo-type-details"
                            style="cursor: pointer"
                        >
                            <a-icon
                                icon="Info"
                                class="text-secondary mr-2"
                            ></a-icon>
                            <span>{{ promoType }}</span>
                            <a-icon
                                icon="Chevron"
                                :iconConfig="{
                                    up: showPromoTypeDetails,
                                    down: !showPromoTypeDetails
                                }"
                            />
                        </div>
                        <div
                            class="collapse mt-2 mb-2 card px-3 py-2"
                            :id="`promo-type-details`"
                            :class="{ show: showPromoTypeDetails }"
                        >
                            <p class="card-text font-weight-bold m-0">
                                {{ setPromoTypeDetails.title }}
                            </p>
                            <p class="card-text m-0">
                                {{ setPromoTypeDetails.details }}
                            </p>
                        </div>
                    </div>
                    <div class="v-promo__category" v-else>
                        <span class="typo">{{ promoType }}</span>
                    </div>

                    <div class="v-promo__image c-fig c-fig--promos">
                        <img
                            :src="promotion.logo.urls.big"
                            class="c-fig__img"
                            width="178"
                            height="118"
                        />
                    </div>

                    <div class="v-promo__brand">
                        <div class="c-fig c-fig--logo">
                            <img
                                :src="promotion.company.logo.urls.small"
                                alt
                                class="c-fig__img"
                            />
                        </div>
                    </div>
                </div>
                <div class="v-promo__desktop-infographic">
                    <promotions-infographic
                        :maximize="allowToInfographicMaximize"
                        :infographic="promotion.infographic"
                    />
                </div>
            </header>
            <div class="v-promo__boxes">
                <div class="row">
                    <div class="col-md-6 col-lg-4">
                        <h3 class="typo typo--headline mb-3">Szczegóły</h3>
                        <div class="tr-data is-column">
                            <div class="tr-data__cell">
                                <span class="tr-data__dt"
                                    >Czas trwania promocji</span
                                >
                                <span class="tr-data__dd">{{
                                    durationDays | plurals('dzień', 'dni')
                                }}</span>
                            </div>
                            <div class="tr-data__cell">
                                <span class="tr-data__dt">{{
                                    daysLeft.countText
                                }}</span>
                                <span class="tr-data__dd">{{
                                    daysLeft.diff
                                }}</span>
                            </div>
                            <div class="tr-data__cell">
                                <span class="tr-data__dt"
                                    >Limit użyć na paragonie</span
                                >
                                <span class="tr-data__dd">{{
                                    promotion.usage_limit_per_receipt
                                        ? promotion.usage_limit_per_receipt
                                        : '-'
                                }}</span>
                            </div>
                            <div class="tr-data__cell tr-data__cell--text">
                                <span class="tr-data__dt"
                                    >Tekst na paragonie</span
                                >
                                <span
                                    class="tr-data__dd"
                                    v-html="promotion.discount_text"
                                ></span>
                            </div>
                            <div
                                class="tr-data__cell"
                                v-if="promotion.type === 'Promo::SalesTarget'"
                            >
                                <span class="tr-data__dt">Nagroda</span>
                                <span class="tr-data__dd">{{
                                    this.promotionAward | currency
                                }}</span>
                            </div>
                            <div
                                class="tr-data__cell tr-data__cell--text"
                                v-if="promotion.type === 'Promo::SalesTarget'"
                            >
                                <span class="tr-data__dt"
                                    >Warunki spełnienia celu sprzedażowego</span
                                >
                                <span
                                    class="tr-data__dd"
                                    v-html="
                                        promotion.conditions_for_sales_target
                                    "
                                ></span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-4 mt-5 mt-lg-0">
                        <h3 class="typo typo--headline mb-3">Akcje</h3>
                        <!-- TODO : marża -->
                        <!-- <div class="tr-data is-column">
                            <div class="tr-data__cell">
                                <span class="tr-data__dt">Twoja marża</span>
                                <span class="tr-data__dd">10%</span>
                            </div>
                        </div>-->

                        <div class="row mt-2">
                            <div
                                class="col"
                                v-if="
                                    promotion.state !== 'finished' &&
                                        allowAcceptPromo &&
                                        allowAcceptPromo.allow
                                "
                            >
                                <the-btn
                                    :text="'Aktywuj promocję'"
                                    class="btn-block btn-outline-custom"
                                    v-tooltip="allowAcceptPromo.buttonText"
                                    @click.native="activatePromo"
                                ></the-btn>
                            </div>
                            <div
                                class="col"
                                v-if="
                                    promotion.state !== 'finished' &&
                                        allowLabels &&
                                        !$store.getters.unavailablePromoTypeCodes.includes(
                                            promotion.promo_type_code
                                        )
                                "
                            >
                                <the-btn
                                    :text="'Generuj cenówki'"
                                    :mobileText="'Cenówki'"
                                    class="btn-block btn-outline-custom"
                                    :icon="'CalcFat'"
                                    v-tooltip="{
                                        content: !allowLabels
                                            ? generateLabelsText
                                            : null
                                    }"
                                    @click.native="generateLabels"
                                ></the-btn>
                            </div>
                        </div>

                        <the-btn
                            v-if="promotion.happy_hours"
                            @click.native="happyHours"
                            :text="'Podgląd Happy Hours'"
                            :class="'btn-block btn-outline-custom mt-3'"
                            :icon="'Promo'"
                        ></the-btn>

                        <the-btn
                            v-if="
                                promotion.terms && promotion.terms.urls.original
                            "
                            @click.native="downloadTerms"
                            :text="'Pobierz warunki promocji'"
                            :class="'btn-block btn-outline-custom mt-3'"
                        ></the-btn>
                        <the-btn
                            v-if="
                                promotion.attachment &&
                                    promotion.attachment.urls.original
                            "
                            @click.native="onAttachmentsDownload"
                            :class="'btn-block btn-outline-custom mt-3'"
                        >
                            <a-icon
                                icon="Download"
                                :iconClass="'text-secondary'"
                            />Pobierz materiały promocyjne
                        </the-btn>
                        <the-btn
                            v-if="subscriptionsToStop.length > 0"
                            @click.native="stopPromo"
                            :text="'Przerwij promocję'"
                            :class="'btn-block btn-outline-custom mt-3'"
                            :icon="'Cancel'"
                        ></the-btn>
                    </div>

                    <div
                        class="col-lg-4 mt-5 mt-lg-0"
                        style="padding-top: 2.5rem"
                    >
                        <promotion-slider
                            :data="promotion.attachments"
                            v-if="
                                promotion.attachments &&
                                    promotion.attachments.length
                            "
                        />
                    </div>
                    <div class="v-promo__mobile-infographic">
                        <promotions-infographic
                            :maximize="allowToInfographicMaximize"
                            :infographic="promotion.infographic"
                        />
                    </div>
                </div>
            </div>

            <section class="mt-5">
                <h2
                    class="h5 font-weight-medium mb-3"
                    v-if="productTriggers.length > 0"
                >
                    Wyzwalacze
                </h2>
                <div
                    class="product-list mb-5"
                    v-if="productTriggers.length > 0"
                >
                    <div class="c-table">
                        <div class="c-thead">
                            <div class="c-tw w-names">
                                <div class="c-td c-promos-image"></div>
                                <div class="c-td">Promocja</div>
                            </div>
                            <div class="c-tw w-numbers">
                                <div class="c-td">Zwrot netto</div>
                                <div class="c-td">Min. liczba</div>
                            </div>
                        </div>
                        <div class="c-tbody">
                            <template>
                                <promo-product
                                    v-for="(product, idx) in productTriggers"
                                    :key="idx"
                                    :product="product"
                                    :productTriggers="true"
                                />
                            </template>
                        </div>
                    </div>
                </div>

                <template v-if="promotion.products.length > 0">
                    <h2 class="h5 font-weight-medium mb-3">
                        Produkty promocyjne
                    </h2>
                    <div class="product-list">
                        <div class="c-table">
                            <div class="c-thead">
                                <div class="c-tw w-names">
                                    <div class="c-td c-promos-image"></div>
                                    <div class="c-td">Produkty</div>
                                </div>
                                <div class="c-tw w-numbers">
                                    <div
                                        class="c-td"
                                        v-if="
                                            promotion.type !==
                                                'Promo::SalesTarget'
                                        "
                                    >
                                        Zwrot netto
                                    </div>
                                    <div
                                        class="c-td"
                                        v-if="
                                            promotion.type !==
                                                'Promo::SalesTarget'
                                        "
                                    >
                                        Min. liczba
                                    </div>
                                    <div
                                        class="c-td"
                                        v-if="
                                            promotion.type ===
                                                'Promo::Percentage'
                                        "
                                    >
                                        Rabat
                                    </div>
                                    <div
                                        class="c-td"
                                        v-else-if="products.length > 0"
                                    >
                                        Max. cena
                                    </div>
                                </div>
                                <!-- TODO : cena zakupu -->
                                <!-- <div class="c-td w-actions">
                                <span>Cena zakupu u dystrybutora</span>
                                <tooltip-info
                                    :text="'Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero, saepe!'"
                                ></tooltip-info>
                                </div>-->
                            </div>
                            <div class="c-tbody">
                                <template v-if="products.length > 0">
                                    <promo-product
                                        v-for="(product, idx) in products"
                                        :key="idx"
                                        :product="product"
                                        :promoType="promotion.type"
                                    />
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="promotion.product_sets.length > 0">
                    <div v-if="promotion.type === 'Promo::MixPromotional'">
                        <products-set-preview
                            :show-set-price="false"
                            :promotion="promotion"
                            :productsSet="promoMixPromotionalTriggersSet"
                            :index="0"
                            :title="'Zestaw produktów wywołujących promocję'"
                        >
                            <template v-slot:additionalDescription>
                                <p>
                                    Sumaryczna liczba punktów wybranych
                                    produktów musi przekraczać
                                    <strong>{{
                                        promoMixPromotionalTriggersSet.required_weight
                                    }}</strong
                                    >. <br />Dopiero wtedy zostanie naliczona
                                    promocja.<br />Produkty z zestawu pierwszego
                                    sprzedasz w cenie regularnej.
                                </p>
                            </template></products-set-preview
                        >
                        <products-set-preview
                            :promotion="promotion"
                            :productsSet="promoMixPromotionalProductsSet"
                            :index="1"
                            ><template v-slot:additionalDescription>
                                <p>
                                    Sumaryczna liczba punktów wybranych
                                    produktów musi przekraczać
                                    <strong>{{
                                        promoMixPromotionalTriggersSet.required_weight
                                    }}</strong
                                    >. <br />Dopiero wtedy zostanie przyznana
                                    refundacja.<br />Produkty z zestawu drugiego
                                    sprzedasz w cenie zestawu promocyjnego.
                                </p>
                            </template></products-set-preview
                        >
                    </div>
                    <div v-else>
                        <div
                            class="product-set"
                            v-for="(productsSet, idx) in promotion.product_sets"
                            :key="idx"
                        >
                            <products-set-preview
                                :promotion="promotion"
                                :productsSet="productsSet"
                                :index="idx"
                            />
                        </div>
                    </div>
                </template>
            </section>

            <section class="mt-5">
                <h2 class="h5 font-weight-medium mb-3">
                    Status promocji w sklepach
                </h2>

                <div class="form-group input-with-icon promo-details-search">
                    <search-input
                        :placeholder="'Wyszukaj sklep'"
                        :name="'Search'"
                        @change="searchInput = $event"
                    ></search-input>
                </div>
                <div class="shops-list">
                    <div class="c-table">
                        <div class="c-thead">
                            <div class="c-td w-name">Nazwa i adres sklepu</div>
                            <div class="c-tw w-middle">
                                <div class="c-tw w-stats">
                                    <div class="c-td">Ostatnia zmiana</div>
                                    <!-- TODO : użytkownik -->
                                    <!-- <div class="c-td">Użytkownik</div> -->
                                    <div class="c-td">Status promocji</div>
                                </div>
                                <div class="c-tw w-ean text-center">
                                    <div class="c-td">
                                        {{
                                            promotion.products.length > 0
                                                ? 'Produkt'
                                                : 'Zestaw'
                                        }}
                                    </div>
                                    <div
                                        class="c-td pr-4"
                                        v-if="
                                            promotion.type ===
                                                'Promo::Percentage'
                                        "
                                    >
                                        Rabat
                                    </div>
                                    <div
                                        class="c-td pr-4"
                                        v-else-if="
                                            promotion.type !==
                                                'Promo::Supply' &&
                                                promotion.type !==
                                                    'Promo::SalesTarget'
                                        "
                                    >
                                        Cena
                                    </div>
                                </div>
                            </div>
                            <div class="c-td w-actions">
                                <div class="form-check form-check-inline">
                                    <div>
                                        <ui-checkbox-input
                                            class="c-thead"
                                            name="selectAllSubsData"
                                            v-model="selectAllSubsData"
                                            label="Wszystkie"
                                            :disabled="
                                                promotion.subscriptions.filter(
                                                    el =>
                                                        el.state === 'available'
                                                ).length === 0
                                            "
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="c-tbody">
                            <subscription-preview
                                @changeAllowDeselectAll="deselectAll"
                                v-for="(subscription, idx) in searchedSubs"
                                :key="idx"
                                :data="subscription"
                                :promoId="promotion.id"
                                :promoType="promotion.type"
                            ></subscription-preview>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div
            class="selected"
            data-selected-bar
            style="position: sticky; top: 0px"
            v-if="selectedSubscriptionsLength > 0"
        >
            <div class="selected-header">
                <div class="container selected-header-content">
                    <span class="selected-heading">
                        Wybrałeś:
                        <span>{{
                            selectedSubscriptionsLength
                                | plurals('sklep', 'sklepy', 'sklepów')
                        }}</span>
                    </span>
                    <div>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            @click="acceptPromos"
                        >
                            Zaakceptuj wybrane sklepy
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import moment from 'moment'
import PromoProduct from '@/components/promotions/PromoProduct'
import ProductsSetPreview from '@/components/promotions/ProductsSetPreview'
import SubscriptionPreview from '@/components/promotions/SubscriptionPreview'
import PromotionSlider from '@/components/promotions/PromotionSlider'
import PromotionsInfographic from '@/components/promotions/PromotionsInfographic'
export default {
    data() {
        return {
            showPromoTypeDetails: false,
            slider: !false,
            allowDeselectAll: true,
            promotionIncoming: null
        }
    },
    components: {
        PromoProduct,
        SubscriptionPreview,
        PromotionSlider,
        PromotionsInfographic,
        ProductsSetPreview
    },
    computed: {
        promotionAward() {
            let promotionAward = this.promotion.prize_amount

            if (this.promotion.sales_target_thresholds.length > 0) {
                const prices = this.promotion.sales_target_thresholds.map(
                    e => +e.prize_amount
                )
                const largestPrice = prices
                    .sort((a, b) => {
                        return a - b
                    })
                    .pop()
                promotionAward = largestPrice
            }

            return promotionAward
        },
        promoMixPromotionalTriggersSet() {
            if (this.promotion.type === 'Promo::MixPromotional') {
                return this.promotion.product_sets.find(
                    set => set.type === 'ProductSet::Trigger'
                )
            } else {
                return null
            }
        },
        promoMixPromotionalProductsSet() {
            if (this.promotion.type === 'Promo::MixPromotional') {
                return this.promotion.product_sets.find(
                    set => set.type === 'ProductSet::Promotional'
                )
            } else {
                return null
            }
        },
        generateLabelsText() {
            if (this.promotion.type === 'Promo::Mix') {
                return 'Funkcjonalność nie jest dostępna dla promocji typu PromoMix.'
            } else {
                return 'Aby pobrać cenówkę aktywuj promocję.'
            }
        },
        startAt() {
            return moment(this.promotion.start_at).format('DD-MM-YYYY, HH:mm')
        },
        finishAt() {
            return moment(this.promotion.finish_at).format('DD-MM-YYYY, HH:mm')
        },
        durationDays() {
            const start = moment(this.promotion.start_at)
            const end = moment(this.promotion.finish_at)
            return Math.ceil(end.diff(start, 'days', true))
        },
        daysLeft() {
            return this.$store.getters.getDaysLeft(this.promotion)
        },
        promotion() {
            return this.$store.getters.getPromotion
        },
        products() {
            let products = []
            if (this.promotion.products.length > 0) {
                products = this.promotion.products.filter(el => el.promotional)
            }
            return products
        },
        productTriggers() {
            if (this.promotion.products.length > 0) {
                return this.promotion.products.filter(el => !el.promotional)
            } else {
                return []
            }
        },
        computedProducts() {
            if (this.promotion.products.length > 0) {
                return this.promotion.products
            } else if (this.promotion.product_sets.length > 0) {
                const products = this.promotion.product_sets.map(
                    el => el.product_set_dict_products
                )[0]
                return products
            } else {
                return false
            }
        },
        promotionStatus() {
            return this.$store.getters.getPromotionStatus
        },
        merchants() {
            return this.$store.getters.getMerchants
        },
        selectAllSubsData: {
            get() {
                return this.$store.getters.getSelectAllMerchants
            },
            set(value) {
                // if (value) {
                this.deselectAll()
                this.$store.dispatch('selectAllMerchants', {
                    promoId: this.promotion.id,
                    shops: this.promotion.subscriptions
                        .filter(el => el.state === 'available')
                        .map(el => el.merchant_id),
                    value: value
                })
                // }
            }
        },
        searchInput: {
            get() {
                return this.$store.getters.getMerchantSearch
            },
            set(value) {
                this.$store.dispatch('searchMerchants', value)
            }
        },
        searchedSubs() {
            // return shop list
            let merchants = this.merchants

            merchants = merchants
                .filter(item => {
                    return item.name
                        .toLowerCase()
                        .includes(this.searchInput.toLowerCase())
                })
                .map(item => item.id)

            return this.promotion.subscriptions.filter(shop => {
                return merchants.includes(shop.merchant_id)
            })
        },
        promoType() {
            return this.$store.getters.getPromoTypeByValue(this.promotion.type)
        },
        allowToInfographicMaximize() {
            return this.promotion.type === 'Promo::SalesTarget'
        },
        subscriptionsToStop() {
            return this.$store.getters.getSubscriptionsToStop
        },
        selectedSubscriptionsLength() {
            return this.$store.getters.getSelectedSubscriptionsByPromoId(
                this.promotion.id
            )
        },
        allowLabels() {
            let allow = false
            const checkActiveSub = this.promotion.subscriptions.find(
                el => el.state === 'accepted'
            )
            if (checkActiveSub && this.promotion.type !== 'Promo::Mix') {
                allow = true
            }
            return allow
        },
        allowAcceptPromo() {
            const acceptPromo = {
                allow: false,
                buttonText: ''
            }
            if (this.promotion.subscriptions) {
                const statuses = this.promotion.subscriptions.map(
                    el => el.state
                )
                if (statuses.includes('available')) {
                    acceptPromo.allow = true
                    acceptPromo.buttonText =
                        'Aktywuj tę promocję we wszystkich sklepach'
                } else if (statuses.includes('interrupted')) {
                    acceptPromo.buttonText =
                        'Ponowna akceptacja promocji będzie możliwa jutro'
                } else if (statuses.includes('accepted')) {
                    acceptPromo.buttonText = 'Ta promocja już jest aktywna'
                }
                if (statuses.every(el => el === 'conflict')) {
                    acceptPromo.buttonText =
                        'Nie możesz aktywować tej promocji ze wględu na konflikty'
                }
            }
            return acceptPromo
        },
        actionButtonsCount() {
            let count = 0
            if (this.allowAcceptPromo.allow) {
                count++
            }
            if (this.allowLabels) {
                count++
            }
            if (this.promotion.happy_hours) {
                count++
            }
            if (this.subscriptionsToStop.length > 0) {
                count++
            }
            return count
        },
        setPromoTypeDetails() {
            const promoTypeDetails = {
                title: '',
                details: ''
            }
            switch (this.promotion.type) {
            case 'Promo::Supply':
                promoTypeDetails.title =
                        'Utrzymuj cenę rekomendowaną przez organizatora promocji i zyskuj refundację za każdą sprzedaż produktu.'
                promoTypeDetails.details =
                        'Uwaga, promocja typu Zapas nie zmienia automatycznie ceny produktu na promocyjną w urządzeniach fiskalnych. Aby otrzymać refundację aktywuj promocję i dokonaj ręcznej modyfikacji ceny na promocyjną lub niższą.'
                break
            case 'Promo::Percentage':
                promoTypeDetails.title =
                        'Utrzymuj rabat określony w promocji i otrzymuj refundację za każdą sprzedaż produktu.'
                break
            case 'Promo::VirtualSet':
                promoTypeDetails.title =
                        'Sprzedaj wymaganą liczbę sztuk wszystkich produktów objętych promocją i zyskuj refundację za każdy sprzedany zestaw.'
                break
            case 'Promo::PromoItemFixedPrice':
                promoTypeDetails.title =
                        'Sprzedaj wymaganą liczbę sztuk produktu objętego promocją i zyskuj refundację za każdy sprzedany zestaw.'
                break
            case 'Promo::Mix':
                promoTypeDetails.title =
                        'Sprzedaj wymaganą liczbę sztuk dowolnych produktów objętych promocją i zyskuj refundację za każdy sprzedany zestaw.'
                break
            case 'Promo::Mix1':
                promoTypeDetails.title =
                        'Sprzedaj wymaganą liczbę sztuk dowolnych produktów objętych promocją i zyskuj refundację za każdy sprzedany zestaw.'
                break
            case 'Promo::PeriodicPriceReduction':
                promoTypeDetails.title =
                        'Sprzedaj promowany produkt w cenie nie wyższej niż określona w definicji promocji i otrzymaj refundację za każdą sprzedaż.'
                promoTypeDetails.details =
                        'Uwaga: po określeniu przez Ciebie ceny produktów biorących udział w promocji, zostanie ona automatycznie zmieniona na rozwiązaniach fiskalnych zgodnie z harmonogramem obowiązywania promocji.'
                break
            case 'Promo::PromoItemPromotional':
                promoTypeDetails.title =
                        'Sprzedaj wymaganą liczbę sztuk określonych produktów z dwóch grup i zyskuj refundację za każdy sprzedany zestaw.'
                promoTypeDetails.details =
                        'Uwaga, tylko produkty oznaczone jako promocyjne są objęte refundacją. Aby otrzymać refundację wymagana jest sprzedaż określonej liczby sztuk z obu grup produktów w promocji.'
                break
            case 'Promo::SalesTarget':
                promoTypeDetails.title =
                        'Sprzedaj wymaganą liczbę sztuk produktów objętych akcją i otrzymaj nagrodę.'
                break
            case 'Promo::MixPromotional':
                promoTypeDetails.title =
                        'Sprzedaj wymaganą liczbę sztuk dowolnych produktów z dwóch grup i zyskuj refundację za każdy sprzedany zestaw.'
                promoTypeDetails.details =
                        'Uwaga, tylko produkty oznaczone jako promocyjne są objęte refundacją. Aby otrzymać refundację wymagana jest sprzedaż określonej liczby sztuk z obu grup produktów w promocji.'
                break
            case 'Promo::RegularPrice':
                promoTypeDetails.title =
                        'Ustaw obowiązującą cenę regularną produktów poprzez aktywację tej oferty.'
                break
            default:
                break
            }
            return promoTypeDetails
        }
    },
    created() {
        this.allowDeselectAll = true
        this.$store.dispatch('promotionFetch', {
            promoId: this.$route.params.id,
            includes:
                'conditions_for_sales_target,attachments,infographic,company,products,attachment,logo,company.logo,product.dict_product,product_sets,product_set.product_set_dict_products,product_set_dict_product.dict_product,dict_product.image,product_set_dict_product.image,terms,sales_target_thresholds'
        })
        window.scrollTo(0, 0)
    },
    beforeDestroy() {
        this.$store.dispatch('setSelectAllMerchants', false)
    },
    methods: {
        activatePromo() {
            if (this.allowAcceptPromo.allow) {
                this.deselectAll()
                this.$store.dispatch('selectAllMerchants', {
                    promoId: this.promotion.id,
                    shops: this.promotion.subscriptions
                        .filter(el => el.state === 'available')
                        .map(el => el.merchant_id),
                    value: true
                })
                this.acceptPromos()
            }
        },
        happyHours() {
            this.$store.dispatch('openModal', {
                component: 'HappyHours'
            })
        },
        stopPromo() {
            this.$store.dispatch('openModal', {
                component: 'StopPromotion'
            })
        },
        acceptPromos() {
            if (this.$store.getters.isLotteryUser) {
                this.$store.dispatch('onLotteryUserNoPermission')
            } else {
                history.pushState({}, null, '/cart')
                this.$store.dispatch('openModal', {
                    component: 'ModalPromoAccept',
                    classes: 'modal--accept',
                    args: {
                        promoId: this.promotion.id
                    }
                })
            }
        },
        deselectAll() {
            if (this.allowDeselectAll) {
                this.allowDeselectAll = false
                this.$store.dispatch('selectAllPromotions', false)
            }
        },
        toggleFavorites(promoId) {
            this.$store
                .dispatch('toggleFavorites', {
                    promoId: promoId,
                    favorite: this.promotion.favorite
                })
                .then(response => {
                    if (response.status === 200) {
                        this.promotion.favorite = !this.promotion.favorite
                    }
                })
        },
        generateLabels() {
            if (this.allowLabels) {
                this.$store.dispatch('openModal', {
                    component: 'GenerateLabels'
                })
            }
        },
        onAttachmentsDownload() {
            this.$store.dispatch('fetchPromotionAttachments', {
                id: this.promotion.id,
                name: this.promotion.name
            })
        },
        downloadTerms() {
            const file = this.promotion.terms.urls.original
            if (file) {
                const link = document.createElement('a')
                link.href = file
                link.target = '_blank'
                link.setAttribute('download', true)

                // Firefox requires the link to be in the body
                document.body.appendChild(link)

                link.click()
                document.body.removeChild(link)
            }
        }
    }
}
</script>
